import React, { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CustomToolTibe from "../../../../Common/CustomToolTibe";
function OrganizerInfo({ data }) {
  const dispatch = useDispatch();
  const { classData, user_type } = useSelector(state => state);
  const handlerPrice = pprice => {
    if ("second_price" in pprice) {
      return (
        <>
          <div className="d-flex">
            <del
              style={
                {
                  // color: "red",
                }
              }
              className="shift-data"
            >{` ${pprice.price}`}</del>
            <div style={{ marginRight: "5px" }} className="shift-data">{`${
              pprice && pprice.second_price
            } تومان`}</div>
          </div>
        </>
      );
    } else {
      return <div>{`${pprice && pprice.price} تومان`}</div>;
    }
  };

  const btn = () => {
    if (data.capacity != 0) {
      if (user_type) {
        return (
          <Link
            className="btnReserveClass d-flex justify-content-between mt-4"
            onClick={() => {
              let obj = {
                ...classData,
                ...data,
              };
              dispatch({
                local_storage: {
                  key: "classData",
                  value: obj,
                },
                type: "SET",
                payload: { classData: obj },
              });
            }}
            to={`/Classes/ClassOrder/${"registeForme"}`}
          >
            <p>رزرو کلاس</p>
            <p>{handlerPrice(data.price)}</p>
          </Link>
        );
      } else {
        return (
          <CustomToolTibe
            btnText={
              <>
                {" "}
                <p>رزرو کلاس</p>
                <p>{handlerPrice(data.price)}</p>
              </>
            }
            classBtn={
              "btnReserveClass d-flex justify-content-between mt-4 w-100"
            }
            text={"لطفا ابتدا ثبت نام کنید یا وارد شوید"}
            placement={"bottom"}
          />
        );
      }
    } else {
      return (
        <CustomToolTibe
          btnText={
            <>
              {" "}
              <p>رزرو کلاس</p>
              <p>{handlerPrice(data.price)}</p>
            </>
          }
          classBtn={
            " btnReserveClass d-flex justify-content-between mt-4 w-100"
          }
          text={"ظرفیت کلاس به پایان رسیده است"}
          placement={"bottom"}
        />
      );
    }
  };

  return (
    <Fragment>
      <div className="m-3">
        <div
          className="cutumBorder card cardSingle "
          style={{
            backgroundColor: "#fff",
          }}
        >
          <div className="card">
            <div className="card-body p-12 " style={{ textAlign: "center" }}>
              <div className="d-flex  align-items-center">
                <i
                  className="fas fa-clipboard-list m-1"
                  style={{ fontSize: "35px" }}
                />
                <h5>اطلاعات برگزار کننده</h5>
              </div>
              <hr />
              <div>
                <span>ادرس برگزار کننده :</span>
                <span style={{ marginRight: "5px" }}>
                  {data &&
                    data.organizer_details &&
                    data.organizer_details.address}
                </span>
              </div>
              <div>
                <span>شماره تلفن برگزار کننده :</span>
                <span style={{ marginRight: "5px" }}>
                  {data &&
                    data.organizer_details &&
                    data.organizer_details.phone}
                </span>
              </div>
            </div>
          </div>
        </div>
        {data && btn()}
      </div>
    </Fragment>
  );
}

export default OrganizerInfo;
